import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneInputCode.styl';

/**
 * @event onEnter {value:string} при нажатии на enter
 * @event onInput {value:string}
 * @event onFocus {}
 * @event onBlur {}
 */
Vue.component('BXmakerAuthuserphoneInputCode',
    {
        props: {
            value: {
                type: [String, Boolean],
                default: false,
            },
            validationMessage: {
                type: [String, Boolean],
                default: false
            },
            maxLength: {
                type: Number,
                default: 4
            },
            loader: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                inFocus: false,
            };
        },
        computed: {
            classes() {
                let ar = [];
                if (this.inFocus || (this.value && this.value.length > 0)) {
                    ar.push('bxmaker-authuserphone-input-code--focus');
                }
                if (this.validationMessage) {
                    ar.push('bxmaker-authuserphone-input-code--invalid');
                }

                return ar;
            }
        },
        methods: {
            onFocus() {
                this.inFocus = true;
                this.$emit('onFocus');
            },
            onBlur() {
                this.inFocus = false;
                this.$emit('onBlur');
            },
            onInput(e) {
                this.$emit('onInput', e.target.value)
            },
            onKeydown(e){
                switch(e.keyCode)
                {
                    case 13://enter
                    {
                        this.$emit('onEnter', e.target.value)
                        return;
                    }
                }
            },
            // активация фокуса на поле
            focus(){
                this.$refs.input.focus();
            }
        },
        template: `
            <div class="bxmaker-authuserphone-input-code " :class="classes" >
                <div class="bxmaker-authuserphone-input-code__field">
                    <input type="otp" name="otp" @focus="onFocus" @blur="onBlur" 
                    @input="onInput" 
                    @keydown="onKeydown" 
                    :value="value ? value : ''" 
                    autocomplete="off" 
                    ref="input" 
                    :maxlength="maxLength">
                    
                    <BXmakerAuthuserphoneLoader v-if="loader" />
                    
                </div>
                <div class="bxmaker-authuserphone-input-code__validation" v-if="validationMessage">{{validationMessage}}</div>                
            </div>
        `,
    });